"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPanelBodyWrapper = exports.StyledInnerWrapper = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _scrollarea = require("../../scrollarea");
/**
 * Styled ScrollArea with some customizations around scrollbars and gutter spaces.
 * Most of the work is done via JS calculations in the PanelBody component but this CSS works to ensure that the cross-browser scrollbar quirks are accounted for in the container
 */
const StyledPanelBodyWrapper = (0, _styled.default)(_scrollarea.ScrollArea)(_ref => {
  let {
    clientId
  } = _ref;
  return `
    div[data-client-id=${clientId}] {
        width: 100%;
        box-sizing: border-box;
        margin: 0;
        overflow-y: scroll;
        @supports(scrollbar-gutter: stable) {
            scrollbar-gutter: stable;
            overflow-y: none;
        }
    }
    
    //customize the keyline color so it matches the panel border styles
    --smar--sds--keyline--color: ${(0, _designTokensReact.color)("color--border--slate--weakest")}; 

    `;
});
exports.StyledPanelBodyWrapper = StyledPanelBodyWrapper;
/**
 * This styled wrapper absolutely positions the content in a scroll area in order to avoid the scrollbar pushing content over, ensuring it always stays positioned and spaced as intended. A few things of note:
 * - @scrollWidth is calculated by rendering a hidden div off-screen with a scrollbar, and calculating the width of that scrollbar, which makes for a great global browser-specific value
 * - that `scrollbarWidth` property is accounted for in the `right` positioning and the `width` calculation to ensure the container is always positioned correctly
 * - from there, any applied / overidden padding works as intended!
 */
const StyledInnerWrapper = _styled.default.div(_ref2 => {
  let {
    scrollbarWidth
  } = _ref2;
  return `
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    right: -${scrollbarWidth}px;
    width: calc(100% + ${scrollbarWidth}px);
    padding-top: var(--smar--sds--panel-body--padding--top, ${_designTokens.space.space20});
    padding-right: var(--smar--sds--panel-body--padding--right, ${_designTokens.space.space45});
    padding-bottom: var(--smar--sds--panel-body--padding--bottom, ${_designTokens.space.space20});
    padding-left: var(--smar--sds--panel-body--padding--left, ${_designTokens.space.space45});
    box-sizing: border-box;
`;
});
exports.StyledInnerWrapper = StyledInnerWrapper;
//# sourceMappingURL=StyledPanelBodyComponents.js.map